import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export const CardTitle = styled.h3`
  margin: 0 0 16px;
  font-size: ${fontSize.font18};
  font-weight: ${fontWeight.black};
  color: ${theme.blackText};
`;

export const PolicyCardContainer = styled.div<{
  $bgColor?: string;
  $borderRadius?: string;
}>`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  background: ${({ $bgColor }) => $bgColor ?? theme.lightBlueBg};
  border-radius: ${({ $borderRadius }) => $borderRadius ?? "8px"};
  padding: 12px;
  margin-bottom: 16px;
`;

export const PolicyCardLeft = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PolicyCardTitle = styled.p`
  margin: 0;
  font-size: ${fontSize.font16};
  font-weight: ${fontWeight.bold};
  color: ${theme.blackText};
`;

export const PolicyCardRoute = styled.p`
  margin: 0;
  font-size: ${fontSize.font14};
  color: ${theme.greyText6};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PolicyCardRight = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
`;

export const PaxTrigger = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;

  &:disabled {
    cursor: default;
  }
`;

export const PaxWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: ${fontSize.font14};
  color: ${theme.greyText6};
`;

export const PaxChevron = styled.span`
  display: flex;
  align-items: center;
  transform: rotate(180deg);
`;

export const PromptText = styled.p`
  margin: 0 0 12px;
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.bold};
  color: ${theme.blackText};
`;

export const CategoryRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid ${theme.darkGreyBg};
  cursor: pointer;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const CategoryIcon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const CategoryTitle = styled.span`
  flex: 1;
  font-size: ${fontSize.font14};
  color: ${theme.blackText};
`;

export const ChevronWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transform: rotate(90deg);
`;

export const DisclaimerBox = styled.div<{ $bgColor?: string }>`
  background: ${({ $bgColor }) => $bgColor ?? theme.yellowText2};
  border-radius: 12px;
  padding: 12px;
  margin-top: 16px;
  font-size: ${fontSize.font12};
  color: ${theme.greyText3};
`;
